module.exports = __webpack_public_path__ + "static/media/25181860_1545557772160525_488247322_n_edited.9335c72d.jpg";